import "bootstrap";
import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";

const galleryLightbox = document.getElementById("galleryLightbox");

if (galleryLightbox) {
  const lightbox = new PhotoSwipeLightbox({
    gallery: "#galleryLightbox",
    children: "a",
    pswpModule: () => import("photoswipe/dist/photoswipe.esm.js")
  });

  lightbox.init();
}
